import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core';
import React from 'react';
import { serviceTypeMappingColumns } from '../../constants/MockData';
import { IsSectionVisible, UpdateColumnWithConfiguration } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import { apiBatchRequest, apiPost, apiPut } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import ReactChipInput from '../common/ChipInput/ReactChipInput';
import { ShowToast, toastType } from '../../utils/toast-service';
import store from '../../store/appStore';
import { SECTIONS } from '../../constants/appConstants';

export default class ServiceTypeEmailMappings extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      serviceTypeMasterData: [],
      serviceTypeEmailMappingData: [],
      isInAddMode: false,
      selectedEditRowId: undefined,
      updateData: {
        cloudOrgid: 0,
        createdBy: null,
        createdDate: null,
        email: '',
        emailBcc: '',
        emailCc: '',
        emailMappingId: 0,
        modifiedBy: '',
        modifiedDate: '',
        serviceType: '',
        serviceTypeId: 0,
        statusId: 0
      }
    };
  }

  componentDidMount () {
    this.getRequiredData();
  }

  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Users.GetServiceTypeEmailMappingData,
        key: 'serviceTypeEmailMappingData'
      }
    ])
      .then(({ serviceTypeMasterData, serviceTypeEmailMappingData }) => {
        this._asyncRequest = null;
        if (serviceTypeMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          serviceTypeMasterData: serviceTypeMasterData.data || [],
          serviceTypeEmailMappingData: serviceTypeEmailMappingData.data || []
        });
      })
      .catch((e) => {    
        this._asyncRequest = null;
      });
  };

  saveUpdatedRecord = () => {
    // debugger;
    const newParam = this.state.updateData;
    apiPost({
      url: API_URL.Users.UpdateServiceTypeEmail,
      postBody: newParam
    }
    ).then(({ data: response }) => {
      // debugger;
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? 'Record added successfully.'
            : 'Record updated successfully.',
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined
        });
        this.getRequiredData();
      } else {
        ShowToast(
          response.message,
          toastType.ERROR,
          5000,
          5000
        );
      }
    });
  };

  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined
    });
  };

  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      // updateData: this.state.previousUpdateData
      updateData: undefined
    });
    this.getRequiredData();
  };

  renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
        cellInfo.serviceTypeId === this.state.selectedEditRowId.value
          ? (
          <>
            <Tooltip title="Save Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {}}
              >
                <SaveIcon
                  fontSize="small"
                  size="small"
                  onClick={
                     this.saveUpdatedRecord
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={this.cancelEditMode}
              >
                <CancelIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          </>
            )
          : (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_NOTIFICATION, SECTIONS.ADD_EDIT)) && (
          <Tooltip title="Edit Record">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.setState({
                  selectedEditRowId: {
                    key: 'serviceTypeId',
                    value: cellInfo.serviceTypeId
                  },
                  isInAddMode: false,
                  updateData: cellInfo
                });
              }}
            >
              <EditIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
            )}
      </>
    );
  };

  handleTableEditChange = (value, fieldName, row, addMode) => {
    const serviceTypeData = this.state.serviceTypeMasterData;
    const param = this.state.updateData;
    this.setState({
      previousUpdateData: this.state.updateData
    })
    if (fieldName === 'serviceType') {
      const valueOfServiceType = serviceTypeData.filter(
        (x) => x.serviceType === value
      );
      param.serviceTypeId = valueOfServiceType[0].serviceTypeId;
      param[fieldName] = valueOfServiceType[0].serviceType;
    } else if (fieldName === 'email') {
      param[fieldName] = (value || []).join('|');
    } else if (fieldName === 'emailBcc') {
      param[fieldName] = (value || []).join('|');
    } else if (fieldName === 'emailCc') {
      param[fieldName] = (value || []).join('|');
    } else {
      param[fieldName] = value;
    }

    param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
    param.userEmail =
      param.userEmail === undefined
        ? (((store.getState() || {}).auth || {}).account || {}).username
        : param.userEmail;

    this.setState({ updateData: param });
  };

  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }

    const rowNew = {
      emailMappingId: 0,
      serviceTypeId: 0,
      email: '',
      cloudOrgid: 1,
      modifiedBy: '',
      modifiedDate: undefined
    };

    // const dataArray = this.state.allocationData;
    // dataArray.unshift(rowNew);
    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'serviceTypeId', value: 0 },
      updateData: rowNew
    });
  };

  render () {
    const EditSource = [];
    EditSource.push({
      key: 'serviceTypeMasterData',
      data: this.state.serviceTypeMasterData
    });

    return (

       <>
                <Table
                    aria-labelledby="tableMenuTitle"
                    size={'small'}
                    aria-label="configuration table"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell
                                key={'configureHeader'}
                                className="content-header"
                                colSpan={2}
                            >
                                <div className="content-header d-flex">
                                    {' '}
                                    <div
                                        className="col-xs-11"
                                        style={{ display: 'inline-block', alignItems: 'center' }}
                                    >
                                        Service Type and Email Notification Settings Configuration
                                    </div>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                               <GridTable
          columns={UpdateColumnWithConfiguration(
            serviceTypeMappingColumns,
            [],
            []
          )}
          isInline={true}
          data={this.state.serviceTypeEmailMappingData}
          renderActionColumn={this.renderActionColumn}
          selectedEditRowId={this.state.selectedEditRowId}
          isInAddMode={this.state.isInAddMode}
          EditSource={EditSource}
          handleTableEditChange={this.handleTableEditChange}
          updateData={this.state.updateData}
          // AddNewRecord={{
          //   action: this.AddNewRecord,
          //   title: 'Add New Allocation',
          //   visible: true
          // }}
        ></GridTable>
         </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>

    );
  }
}
